export default "__VITE_ASSET__e918e29e__"